import { IconButton, makeStyles } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { Calendar, DateObject } from 'react-multi-date-picker';
import { datesAreOnSameDay, prettyDate } from "../../config/dateFormatting";
import useOnClickOutside from '../../hooks/useOutsideAlerter';

const useStyles = makeStyles((theme: any) => ({
    container: {
        display: 'grid',
        justifyContent: 'start',
        alignItems: 'center',
        gridTemplateColumns: '50px 250px 50px',
        height: '60px',
        fontSize: 24,
        '& > *': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '100%'
        },
    },
    todayTitle:{
        fontWeight: 'bold',
        paddingRight: 10
    },
    primary: {
        color: theme.palette.primary.main
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    calendar: {
        border: "1px solid black"
    },
    calendarContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: "absolute",
        width: 350,
        "& > *": {
            maxWidth: "300px !important"
        }
    },
    todayLink: {
        color: theme.palette.primary.main,
        display: "flex",
        width: 350,
        justifyContent: "center",
        marginTop: -10,
        "&:hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    }
}));

interface Props { 
    date: Date;
    setDate: React.Dispatch<React.SetStateAction<Date>>;
    isCalendarPicking: boolean;
    setIsCalendarPicking: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CalendarPicker: React.FC<Props> = ({
    date, 
    setDate,
    isCalendarPicking,
    setIsCalendarPicking}) => {

    // Stling
    const classes = useStyles();

    // Click outside calendar
    const ref = useRef(null)

    const handleClickOutside = () => {
        setIsCalendarPicking(false)
    }

    useOnClickOutside(ref, handleClickOutside)

    const toDate = (dateObject: DateObject) : Date => {
        return dateObject.toDate()
    }

    function handleChange(e: any) {
        if(e instanceof DateObject){
            setDate(toDate(e));
        }
    }

    return (
        <div ref={ref}>
            <div className={classes.calendarContainer}>
                <Calendar
                    currentDate={new DateObject()}
                    multiple={false}
                    value={date} 
                    onChange={handleChange}
                    weekStartDayIndex={1}
                    showOtherDays={false}
                    className={classes.calendar}
                    mapDays={({ date }) => {
                        // Styling of today
                        if(datesAreOnSameDay(date.toDate(), new DateObject().toDate())){
                            return {
                                style: { background: "#6178ed7c", color:'white' },
                                id: "today-calendar-date",
                                className: "calendar-date",
                            }
                        }

                        // Styling of weekends
                        let isWeekend = [0, 6].includes(date.weekDay.index)
                        if (isWeekend) return {
                            disabled: true,
                            style: { color: "#ccc" },
                            className: "calendar-date",
                            onClick: () => alert("Weekends are disabled")
                        }

                        // Identifiers for date spans
                        return{
                            className: "calendar-date",
                        }
                    }}
                />
            </div>
        </div>
    );
}